// Material
import { Divider } from '@mui/material'
// Common
import {
  UserListItemSkeleton,
  UserListItemWithStatus,
} from '$common/user-list-item'
import { EmptyStateList } from '$common/empty-state-list'
import { withSearchableListPage } from '$common/searchable-list-page'
import { closeBlockedUsers } from '$logic/router'
import { useFamiliarUserIds, useSearchedFamiliarUserIds } from '$logic/users'
import { blockUser } from '$logic/user-policy'
// Localization
import { t } from '$i18n'
import { removeFromOpenedUserList } from '$logic/opened-user-list'

function ListItem({ id }: { id: string }) {
  return (
    <>
      <UserListItemWithStatus
        userId={id}
        hasDivider={false}
        onClick={async () => {
          analite('BLOCK_USER', {
            active: true,
            source: 'BLOCK_USER_PAGE',
          })
          await blockUser(id)
          removeFromOpenedUserList(id, 'blockUser')
        }}
      />
      <Divider variant="inset" />
    </>
  )
}

const Page = withSearchableListPage<
  { id: string },
  void,
  { query: string; items: { id: string }[] }
>({
  appBarTitle: t('myAccount.blockedUsers.block'),
  ListItem,
  SkeletonItem: UserListItemSkeleton,
  EmptyStateComponent: () => <EmptyStateList />,
  fetchHook: () => useFamiliarUserIds('blockUser'),
  searchHook: useSearchedFamiliarUserIds,
  onBack: closeBlockedUsers,
})

export function BlockUser() {
  return (
    <Page
      fetchHookParams={undefined}
      getSearchHookParams={(query, items) => ({ query, items })}
    />
  )
}
